export const alertIconType = {
    successIcon: 'success',
    errorIcon: 'error',
    infoIcon: 'info',
    questionIcon: 'question'
};